const { REACT_APP_BASE_API_URL } = process.env;

export const metaData = {
  Name: "JustAct",
  FileType: "PDF",
  SignatureMode: "12,1,2,3",
  SelectPage: "ALL",
  SignaturePosition: "Bottom-Right",
  AuthToken: "5a86eee6-79d4-4c50-83be-0aed299779d4",
  File: "",
  PageNumber: 1,
  PreviewRequired: true,
  PagelevelCoordinates: "",
  CustomizeCoordinates: "",
  SUrl: `${REACT_APP_BASE_API_URL}emudhra-final`,
  FUrl: `${REACT_APP_BASE_API_URL}emudhra-final`,
  CUrl: `${REACT_APP_BASE_API_URL}emudhra-final`,
  ReferenceNumber: "956745875ljyduyt8yf866745",
  Enableuploadsignature: true,
  Enablefontsignature: true,
  EnableDrawSignature: true,
  EnableeSignaturePad: false,
  IsCompressed: false,
  IsCosign: false,
  Storetodb: false,
  IsGSTN: false,
  IsGSTN3B: false,
  IsCustomized: false,
  eMudhraV2SignatureType: 2,
  // IsCustomized: true,
  eSign_SignerId: "",
  TransactionNumber: "c9e5a25e166sa84667byiyid8fysifkytfjx",
  AuthenticationMode: 1,
  EnableInitials: false,
  IsInitialsCustomized: false,
  InitialsPosition: "",
  InitialsCustomizeCoordinates: "",
  InitialsPagelevelCordinates: "",
  InitialsPageNumbers: "",
  ValidateAllPlaceholders: false,
  Searchtext: "",
  Anchor: "Middle",
  InitialSearchtext: "",
  InitialsAnchor: "",
  Reason: "",
};
